import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", as = "h1" }) => {
  const Tag = as;
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay: 0.2 + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <p
    className={`text-[11px] sm:text-xs uppercase tracking-[0.3em] font-sans font-semibold ${
      light ? "text-[#1E232A]/50" : "text-[#C5A059]"
    }`}
  >
    {children}
  </p>
);

export const PlaceholderTag = ({ label = "Placeholder" }) => (
  <span
    data-testid="placeholder-tag"
    className="inline-flex items-center gap-1 border border-dashed border-[#C5A059]/60 text-[#C5A059] text-[10px] uppercase tracking-[0.18em] px-2 py-1 font-sans"
  >
    {label} — replace before publication
  </span>
);
